import { inject, Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';
import { Identify } from '@amplitude/analytics-browser';
import { BsHubService } from '@brightside-web/desktop/data-access/core-services';

@Injectable({
  providedIn: 'root',
})
export class AmplitudeService {

  private _bsHub = inject(BsHubService);

  logEvent(eventName: string, eventProperties?: { [key: string]: string }) {
    eventName = eventName.split('_').join(' ').toLowerCase();
    if (eventProperties && Object.keys(eventProperties).length > 0) {
      const eventProps = this.updateEventPropertiesKeys(eventProperties);
      amplitude.logEvent(eventName, eventProps);
      this._bsHub.dispatch('amplitude', {event:'event_logged', data: {eventName, eventProps}});
    } else {
      amplitude.logEvent(eventName);
      this._bsHub.dispatch('amplitude', {event:'event_logged', data: {eventName}});
    }
  }

  setUserId(userId: string) {
    amplitude.setUserId(userId);
  }

  flush(): Promise<void> {
    return amplitude.flush().promise.then(() => undefined);
  }

  clearProperties(): void {
    // this.amplitudeInstance.setUserId(null);
    // this clears previously stored user properties in Amplitude
    // this.amplitudeInstance.clearUserProperties();
  }

  setUserProperties(userProperties: { [key: string]: string }) {
    const identify = new Identify();
    for (const [key, value] of Object.entries(userProperties)) {
      identify.set(key, value);
    }
    amplitude.identify(identify);
  }

  incrementErrorsViewed() {
    const identify = new amplitude.Identify().add('total errors viewed', 1);
    amplitude.identify(identify);
  }

  updateEventPropertiesKeys(eventProperties?: { [key: string]: string }): { [key: string]: string } | undefined {
    if (!eventProperties) {
      return undefined;
    }

    const updatedProperties: { [key: string]: string } = {};

    for (const [key, value] of Object.entries(eventProperties)) {
      const updatedKey = key.replace(/_/g, ' ');
      updatedProperties[updatedKey] = value;
    }

    return updatedProperties;
  }
}

export const amplitudeWhitelist = [
  'app_opened',
  'app_review',
  'app_update',
  'argyle',
  'biometrics',
  'change_username',
  'chat',
  'create_account',
  'credit',
  'email',
  'error',
  'external_savings',
  'full_ssn',
  'help',
  'help_topic_list',
  'home',
  'home_shown',
  'invite',
  'loading_timed_out',
  'loan',
  'notifications',
  'onboarding',
  'profile',
  'push',
  'savings',
  'select_employer',
  'settings',
  'sign_in',
  'sign_up',
  'verify',
  'home_address',
  'employee_id',
  'web_loaded',
];
